export default "__VITE_ASSET__DR8vDiIW__"